











import { Component, Vue } from "vue-property-decorator";
import { State } from "vuex-class";

@Component
class DefaultLayoutBottomNav extends Vue {
  @State(state => state.app.bottomNav)
  bottomNav;

  animation = false;

  get bottomNavItems() {
    return [
      {
        text: this.$t("common.wallet"),
        icon: "$vuetify.icons.iconWallet",
        path: "index",
        project: "wallet",
        value: "wallet"
      },
      {
        text: this.$t("common.defi"),
        icon: "$vuetify.icons.iconDefi",
        path: "index",
        project: "defi",
        value: "defi"
      },
      {
        text: this.$t("common.buy-sell"),
        icon: "$vuetify.icons.iconTrade",
        path: "quotation",
        project: "trade",
        value: "buy_sell"
      },
      {
        text: this.$t("common.tools"),
        icon: "$vuetify.icons.iconTools",
        path: "tools",
        project: "basis",
        value: "tools"
      },
      {
        text: this.$t("common.mine"),
        icon: "$vuetify.icons.iconMine",
        path: "mine",
        project: "basis",
        value: "mine"
      }
    ];
  }

  handleChange(nav) {
    if (!nav) {
      return;
    }
    if (this.$route.name === nav.project + "-" + nav.path) {
      return;
    }
    this.$helper.toFusionPath(this, nav.project as any, {
      name: nav.path
    });
  }
}
export default DefaultLayoutBottomNav;
